import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  MotivazioneTematica,
  ReportVsmeService,
} from 'src/app/services/report-vsme/report-vsme.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
  selector: 'app-dialog-motivazione-non-applicabilita',
  standalone: false,

  templateUrl: './dialog-motivazione-non-applicabilita.component.html',
  styleUrl: './dialog-motivazione-non-applicabilita.component.scss',
})
export class DialogMotivazioneNonApplicabilitaComponent {
  public formMotivazione = new FormGroup({
    /* Id */
    motivazioneControl: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  constructor(
    public dialogRef: MatDialogRef<DialogMotivazioneNonApplicabilitaComponent>,
    public reportVsmeService: ReportVsmeService,
    private readonly utilityService: UtilityService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      domandaTematica: string;
      descrizioneTematica: string;
      idAmbito: string;
      idRerportVsme: string;
      idTematica: string;
      disable: boolean;
      motivazione: string;
    },
  ) {
    if (data?.motivazione) {
      this.formMotivazione.get('motivazioneControl')?.setValue(data.motivazione);
    }

    if (data?.disable) {
      this.formMotivazione.disable();
    }
  }

  conferma() {
    if (this.formMotivazione.invalid) {
      this.formMotivazione.controls.motivazioneControl.markAsTouched();
      return;
    }

    const esitoMotivazione = {
      confermato: true,
      motivazione: this.formMotivazione.get('motivazioneControl')?.getRawValue(),
    };

    this.dialogRef.close(esitoMotivazione);
  }
}
